import type { NotifyPlugin } from '@@/types/notifyPlugin';
import type { Context } from '@nuxt/types';

let notifyInstance: NotifyPlugin | null = null;
const notifyPlugin = ({ app }: Context): void => {
  notifyInstance = app.$notify;
};

export default notifyPlugin;

export function useNotify (): Readonly<NotifyPlugin> {
  return notifyInstance!;
}
